import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-editgamemasterdetail',
    templateUrl: './editgamemasterdetail.component.html',
    styleUrls: ['./editgamemasterdetail.component.scss'],
    standalone: false
})
export class EditgamemasterdetailComponent implements OnInit {

  Editgamedetailform:FormGroup
  @Output() updateData: EventEmitter<any> = new EventEmitter();

  @Input() game_id:any;
  @Input() Gamename:string;
  @Input() Nextgame:any;
  

  constructor(private formBuilder: FormBuilder,
    public activeroute: ActivatedRoute,
    public activemodel: NgbActiveModal,
    private dataserv: DataService,
    private router : Router,
    private toastService: ToastService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    
    this.Editgamedetailform = this.formBuilder.group({
      game_id: [this.game_id, [Validators.required]],
      Gamename: [this.Gamename, [Validators.required]],
      Nextgame: [this.Nextgame, [Validators.required]]
    });
  }


  submit(){
    this.dataserv.chnggamedetail(this.Editgamedetailform.value).subscribe((res) => {
          this.toastService.showSuccess('Game updated.', 'success');
          // Reload the list
          this.updateData.emit(this.Editgamedetailform.value);
          this.cdr.detectChanges();
          this.closemodel();
      },
      (error) => {
    
          this.cdr.detectChanges();});
  }

  closemodel(){
    this.activemodel.close();
  }


  
}
